import { FindAncestor } from '../../helpers';

const languageSwitcher = document.getElementById('language-switcher');

function initLanguageSwitcher() {
	const button = document.getElementById('language-switcher-button');

	/**
	 * Init
	 */
	function init() {
		button.addEventListener('click', toggleLanguageSwitcher);

		document.addEventListener('click', closeLanguageSwitcher);
	}

	/**
	 * Toggle language switcher
	 */
	function toggleLanguageSwitcher(e) {
		if (languageSwitcher.classList.contains('active')) {
			languageSwitcher.classList.remove('active');
		} else {
			languageSwitcher.classList.add('active');
		}
	}

	/**
	 * Close language switcher when anywhere outside the switcher is clicked. 
	 */
	function closeLanguageSwitcher(e) {
		if (FindAncestor(e.target, 'm-language-switcher') == null ) {
			languageSwitcher.classList.remove('active');
		}
	}

	init();
}

if (languageSwitcher) {
	initLanguageSwitcher();
}